<title>{{ iagPortalFeedbackAndSuggestionsPage.htmlTitle }}</title>
<div class="container">
  <div *ngFor="let section of iagPortalFeedbackAndSuggestionsPage.sections">
    <div [innerHTML]="section.subBody | mdToHtml"></div>
    <h3>{{ section.title }}</h3>
    <div [innerHTML]="section.body | mdToHtml"></div>
  </div>
</div>
